// 承認メールの送信先を driverId → メールアドレス で引ける形にまとめる。
//
// 通常のドライバーはマスタの「メールアドレス」列がそのまま送信先になる。
// 一方 グループ宛通知書（driverId が "group:<ruleId>"）は、集計のために内部で合成した
// 宛先でマスタに行が無いため、この仕組みに乗れず**一度も自動送信できていなかった**
// （本城さん・徳永さん 2026-08-10。AT-STYLE様の通知書が代表の淺田様に届かなかった件）。
// グループ設定の notifyEmail をここで合流させることで、グループ宛にもメールが飛ぶ。

import type { Driver, GroupRule } from "../types";

export function buildEmailByDriverId(
  drivers: Driver[],
  groupRules: GroupRule[] = []
): Record<string, string> {
  const map: Record<string, string> = {};
  for (const d of drivers) {
    const to = (d.email || "").trim();
    if (to) map[d.id] = to;
  }
  for (const r of groupRules) {
    const to = (r.notifyEmail || "").trim();
    if (to) map[`group:${r.id}`] = to; // store.tsx の合成 driverId と同じ形
  }
  return map;
}
